module.exports = __webpack_public_path__ + "img/vertical.655cb24b.png";